import React, { useEffect, useState } from "react";
import { getContentById } from "../../API/content";
import "./Khutbah.css";

export default function Khutbah() {
  const [khutbahData, setKhutbahData] = useState(null);
  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    const data = await getContentById("khutbah");
    setKhutbahData(data);
  };

  return (
    <div className="Khutbah">
      <div className="color"></div>
      <div className="khutbahMain">
        <div className="khutbah-header">
          <h3>It shumuliyyat al-Islam</h3>
          <h1>KHUTBAH</h1>
          <br />
        </div>
        <div className="containerKhutbah">
          {khutbahData?.map((data) => (
            <div className="khutbah-data" key={data.id}>
              <a
                href={`http://${data.link.fields.file.url}`}
                target="_blank"
                rel="noreferrer"
              >
                <img src="assets/pdf-icon.png" alt="pdf" />
                <p>{data.description}</p>
              </a>
            </div>
          ))}
        </div>
      </div>
      <div className="color"></div>
      <div className="bottomKhutbah">
        <h2>OUR ACTIVITIES</h2>
        <br />
        <h1>WHAT WE OFFER</h1>
        <br />
        <img className="our-activities" src="assets/Activities.png" alt="" />
        <img
          className="our-activities-mobile"
          src="assets/whatweoffer.png"
          alt=""
        />
      </div>
      <div className="color"></div>
    </div>
  );
}
